module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-LightItalic-0c1a7207719a0c103fe1b0d0a9641e7b.woff2";